export interface AppConfig {
    apis: {
        ExternalApi: {
            baseUrl: string;
        };
    };
}

export class ConfigService {
    private static instance: ConfigService;
    private config: AppConfig | null = null;
    private loadPromise: Promise<AppConfig> | null = null;

    private constructor() {}

    public static getInstance(): ConfigService {
        if (!ConfigService.instance) {
            ConfigService.instance = new ConfigService();
        }
        return ConfigService.instance;
    }

    public async getConfig(): Promise<AppConfig> {
        if (this.config) {
            return this.config;
        }

        if (this.loadPromise) {
            return this.loadPromise;
        }

        this.loadPromise = this.loadConfig();
        return await this.loadPromise;
    }

    private async loadConfig(): Promise<AppConfig> {
        try {
            const response = await fetch('/config.json');

            if (!response.ok) {
                throw new Error(`Failed to load config: ${response.status} ${response.statusText}`);
            }

            this.config = await response.json();
            console.log(`Loaded configuration successfully`);
            return this.config!;
        } catch (error) {
            console.error('Failed to load application configuration:', error);
            // Fallback to default configuration
            this.config = this.getDefaultConfig();
            return this.config;
        }
    }

    private getDefaultConfig(): AppConfig {
        return {
            apis: {
                ExternalApi: {
                    baseUrl: '',
                },
            },
        };
    }

    public getExternalApiBaseUrl(): string {
        return this.config?.apis?.ExternalApi?.baseUrl ?? '';
    }
}

export const configService = ConfigService.getInstance();
